import React, { useState } from 'react';
import {
  Box, Button, Checkbox, CircularProgress, FormControlLabel, MenuItem, Stack, TextField,
} from '@mui/material';
import PostData from '../../services/PostData';
import SnackbarEx from '../Helpers/SnackbarEx';
import AppDialog from '../ui/AppDialog';
import { states } from '../Inventory/UsStates';

const empty = {
  vendor: '',
  street: '',
  city: '',
  zip: '',
  state: '',
  vendorEmail: '',
  emailOrdering: false,
};

export default function AddNewVendor({ close, open = true }) {
  const [form, setForm] = useState(empty);
  const [submitting, setSubmitting] = useState(false);
  const [snack, setSnack] = useState({ color: '', message: '', open: false });

  const setField = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const handleSubmit = async () => {
    if (!form.vendor.trim()) {
      setSnack({ color: 'error', message: 'Vendor name is required.', open: true });
      return;
    }
    setSubmitting(true);
    const { success } = await PostData(form, 'api/add-vendor', false);
    setSubmitting(false);
    if (success) {
      close('success_add');
    } else {
      setSnack({ color: 'error', message: 'Unable to add vendor.', open: true });
    }
  };

  return (
    <AppDialog
      open={open}
      onClose={() => close(false)}
      title="Add vendor"
      subtitle="Suppliers used for purchases and invoice matching"
      actions={
        <>
          <Button variant="outlined" onClick={() => close(false)} disabled={submitting}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit} disabled={submitting}>
            {submitting ? <CircularProgress size={18} sx={{ color: '#fff' }} /> : 'Save vendor'}
          </Button>
        </>
      }
    >
      <Stack spacing={2}>
        <TextField
          label="Vendor name"
          required
          fullWidth
          value={form.vendor}
          onChange={(e) => setField('vendor', e.target.value)}
        />
        <TextField
          label="Street"
          fullWidth
          value={form.street}
          onChange={(e) => setField('street', e.target.value)}
        />
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
          <TextField
            label="City"
            fullWidth
            value={form.city}
            onChange={(e) => setField('city', e.target.value)}
          />
          <TextField
            select
            label="State"
            fullWidth
            value={form.state}
            onChange={(e) => setField('state', e.target.value)}
          >
            {states.map((s) => (
              <MenuItem key={s} value={s}>{s}</MenuItem>
            ))}
          </TextField>
          <TextField
            label="ZIP"
            fullWidth
            value={form.zip}
            onChange={(e) => setField('zip', e.target.value)}
          />
        </Stack>
        <TextField
          label="Ordering email"
          type="email"
          fullWidth
          value={form.vendorEmail}
          onChange={(e) => setField('vendorEmail', e.target.value)}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={form.emailOrdering}
              onChange={(e) => setField('emailOrdering', e.target.checked)}
            />
          }
          label="Enable email ordering"
        />
      </Stack>

      {snack.open && (
        <SnackbarEx
          color={snack.color}
          message={snack.message}
          open={snack.open}
          close={() => setSnack({ color: '', message: '', open: false })}
        />
      )}
    </AppDialog>
  );
}
